<button
  class="add-button"
  (click)="onClick($event)"
  (mouseenter)="toggleTooltip.emit(true)"
  (mouseleave)="toggleTooltip.emit(false)"
  [disabled]="disabled"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin">
  <span class="icon icon-Plus"></span>
  <span class="label">
    <ng-content select="[appAddButtonLabel]"></ng-content>
  </span>
  <ng-content></ng-content>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="disabled && !tooltipDisabled && (isTooltipOpened$ | async)!"
>
  <ng-container *ngIf="permissionService.roleAbility$ | async as roleAbility">
    <ng-container *ngIf="companyService.companyInfo$ | async as company">
      <div
        class="tooltip"
        (mouseenter)="toggleTooltip.emit(true)"
        (mouseleave)="toggleTooltip.emit(false)">
        <div class="tooltip__container">
          <div *ngIf="companyService.isSubscriptionInactive()" class="suspended">
            <ng-container *ngIf="roleAbility.can(ACTION.MANAGE, SUBJECT.SUBSCRIPTION) else employeeMessageTemplate">
              <span>
                {{'subscription.message.suspended.owner' | translate}}
              </span>
              <div class="tooltip__cta">
                <button class="btn-main btn-secondary-purple btn-xs" (click)="selectPlan()">
                  {{ 'subscription.plan_action.subscribe' | translate }}
                </button>
              </div>
            </ng-container>
            <ng-template #employeeMessageTemplate>
              <span>
                {{ 'subscription.message.suspended.employee' | translate : {billingOwner: company.contactEmployee?.email} }}
              </span>
            </ng-template>
          </div>

          <div *ngIf="companyService.isEmployeesLimitExceed()" class="limit-exceeded">
            <span>
              {{ 'subscription.message.limit_exceed.employee' | translate: {billingOwner: company.contactEmployee?.email} }}
            </span>
          </div>
        </div>
        <span class="tooltip__tail"></span>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
